import { apiOptions, apiRequest } from "../utils";
import { API_V3 } from "../constants";

export const issueDescriptionService = {
  getAll: async (params) => {
    const options = await apiOptions({
      url: `${API_V3}/issuedescriptions`,
      method: "get",
      params,
    });

    return apiRequest(options);
  },

  create: async (request) => {
    const options = await apiOptions({
      url: `${API_V3}/issuedescriptions`,
      method: "post",
      data: request,
    });

    return apiRequest(options);
  },

  update: async (id, request) => {
    const options = await apiOptions({
      url: `${API_V3}/issuedescriptions/${id}`,
      method: "patch",
      data: request,
    });

    return apiRequest(options);
  },

  delete: async (id) => {
    const options = await apiOptions({
      url: `${API_V3}/issuedescriptions/${id}`,
      method: "delete",
    });

    return apiRequest(options);
  },
};
